import styled from 'styled-components';

const bgTypes = theme => ({
  send_email_success: theme.colors.primary,
  confirm_send_email: theme.colors.white,
});

const colorTypes = theme => ({
  send_email_success: theme.colors.white,
  confirm_send_email: theme.colors.gray500,
});

export const Container = styled.div`
  border-radius: 20px;
  text-align: center;
  padding: 57px;

  .icon {
    font-size: 42px;
  }

  .title {
    margin: 16px 0 0;
    display: inline-block;
  }

  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.gray500};

  background: ${({ theme, type }) => bgTypes(theme)[type]};
  color: ${({ theme, type }) => colorTypes(theme)[type]};
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justfy-content: center;
`;

export const Title = styled.text`
  font-size: 24px;
  line-height: 40.8px;
  margin: 16px 0 0;
`;

export const Description = styled.div`
  margin: 20px 0;
`;

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;
